import axios from 'axios';
import { providerListEndpoint } from '../config';
import getHeaders from '../utils/getHeaders';
import { logger } from '../logger';

const log = logger();

const getProviderDevices = async (
  providerId,
  page = 0,
  limit = 200,
) => {
  const customHeaders = { 'cache-control': 'no-cache' };

  try {
    const response = await axios.post(
      `${providerListEndpoint}/${providerId}/provider-devices?limit=${limit}&page=${page}`,
      null,
      getHeaders(customHeaders),
    );
    return response.data;
  } catch (err) {
    log.error('Error in getProviderDevices', err.response);
    return err.response ? err.response : null;
  }
};

const getProviderDeviceExpandedData = async (providerId, assetId) => {
  try {
    const { data } = await axios.get(
      `${providerListEndpoint}/${providerId}/provider-devices/${assetId}`,
      getHeaders(),
    );
    return data ?? [];
  } catch (err) {
    log.error('Error in getProviderDeviceExpandedData', err.response);
    return null;
  }
};

const assignLoaner = async (providerId, assetId, patientId) => {
  try {
    const payload = { assetId, providerId };

    const response = await axios.post(
      `${providerListEndpoint}/patients/${patientId}/assign-loaner`,
      payload,
      getHeaders(),
    );

    return response.data;
  } catch (err) {
    log.error('Error assigning loaner', err);
    return null;
  }
};

const returnLoaner = async (providerId, assetId, patientId) => {
  try {
    const payload = { assetId, providerId };

    const response = await axios.post(
      `${providerListEndpoint}/patients/${patientId}/return-loaner`,
      payload,
      getHeaders(),
    );

    return response.data;
  } catch (err) {
    log.error('Error returning loaner', err);
    return null;
  }
};

export {
  getProviderDevices,
  getProviderDeviceExpandedData,
  assignLoaner,
  returnLoaner,
};
